import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {UserService} from '../../../../services/api/user.service';
import {takeUntil} from 'rxjs/operators';
import {ModalComponent} from '../modal/modal.component';
import {StorageService} from '../../../../services/web/storage.service';
import {NotificationService} from '../../../../services/web/notification.service';
import {indicate} from '../../../../exports/operators';

@Component({
  selector: 'app-enable-mfa',
  templateUrl: 'enable-mfa.component.html',
  styleUrls: ['enable-mfa.component.scss']
})
export class EnableMfaComponent implements OnInit, OnDestroy {
  @Input() public modal: ModalComponent;
  @Input() public modalClosed$: Subject<boolean>;
  @Input() public modalOpened$: Subject<boolean>;
  @Output() public modalClose = new EventEmitter<any>();
  @Output() public totpEnabled = new EventEmitter<any>();
  public qrCode: string;
  public secret: string;
  public showSecret = false;
  public mfaForm: FormGroup;

  public loading$ = new Subject<boolean>();
  private ngUnsubscribe: Subject<void> = new Subject();

  constructor(
    private userService: UserService,
    private formBuilder: FormBuilder,
    private storageService: StorageService,
    private notificationService: NotificationService
  ) { }

  public ngOnInit(): void {
    this.buildForm();
    this.modalClosed$.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe(result => {
      if(result){
        this.showSecret = false;
        this.mfaForm.reset();
      }
    });

    this.modalOpened$.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe(result => {
      if(result){
        this.getQrcode();
      }
    });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public onSubmitTotp(): void {
    if(this.mfaForm.valid){
      this.userService.enableMFA(this.mfaForm.get('secret').value,this.mfaForm.get('totpCode').value)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((response) =>{
          if(!response){
            this.mfaForm.reset();
            this.notificationService.success('MFA has been enabled', 'Success');
            this.storageService.setSessionItem('mfaEnabled', 'true');
            this.modal.closeModal();
          }
        });
    }
  }

  public onRegenerateTotp(): void {
    this.getQrcode();
  }

  public onCloseMfa(): void {
    this.mfaForm.reset();
    this.modal.closeModal();
  }

  public onToggleSecret(): void {
    this.showSecret = !this.showSecret;
  }

  private getQrcode(): void {
    this.userService.getMFAQrCode()
      .pipe(
        indicate(this.loading$),
        takeUntil(this.ngUnsubscribe))
      .subscribe(result => {
      this.qrCode = result.qrcode;
      this.mfaForm.get('secret').setValue(result.secret);
    });
  }

  private buildForm(): void {
    this.mfaForm = this.formBuilder.group({
      totpCode: ['', Validators.required],
      secret: ['', Validators.required]
    });
  }
}
